import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';
import type { AppConfig } from '@/types/config';

type DatadogConfig = NonNullable<AppConfig['datadog']>;

let initialized = false;

export function initDatadog(config: DatadogConfig): void {
    if (initialized || !config.enabled || !config.applicationId || !config.clientToken) return;
    initialized = true;

    datadogRum.init({
        applicationId: config.applicationId,
        clientToken: config.clientToken,
        site: 'datadoghq.com',
        service: 'mvm-web',
        env: config.env ?? 'dev',
        version: config.version,
        sessionSampleRate: config.sessionSampleRate ?? 100,
        sessionReplaySampleRate: config.sessionReplaySampleRate ?? 5,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
    });

    datadogLogs.init({
        clientToken: config.clientToken,
        site: 'datadoghq.com',
        service: 'mvm-web',
        env: config.env ?? 'dev',
        forwardErrorsToLogs: true,
        forwardConsoleLogs: ['error'],
        sessionSampleRate: 100,
    });
}

export function resetDatadogForTesting(): void {
    initialized = false;
}
